import RestClient from '../RestClient/RestClient';

const ZIP_CODE_URL = 'zipCodes';

const getHostConfig = (config) => {
    const context = RestClient.getContext();
    /* istanbul ignore else */
    if (context && context.hostname && context.hostname.indexOf('test') === -1) {
        config.host = 'account-api.jcpenney.com';
        config.isXCloudHeaderRequired = false;
    }
    return config;
};

/**
 * Function to fetch the message content.
 */
export const getCityStateByZipcode = (params) => {
    const config = {
        url: `${ZIP_CODE_URL}/${params.payload}`,
        acceptVersion: '2.1',
        version: '/v2',
    };

    return RestClient.get(config).then((json) => json.data);
};

export const getCityStateByZipCode = (params) => {
    let config = {
        url: `${ZIP_CODE_URL}/${params.payload}`,
        isXCloudHeaderRequired: true,
        host: 'account-api-test.jcpenney.com',
        acceptVersion: '1',
        version: '/v1',
    };

    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};
